import orderBy from 'lodash-es/orderBy';
import uuid from 'uuid';
import { migrateJSON } from '../../migrations';

/**
 * We want every object within a slide to have:
 *
 * - a ludus property
 * - within ludus, a type property (missing from some objects, probably early content)
 * - within ludus, an id property that we will use for rendering within React components
 *
 * @param object
 * @returns {*}
 */
const identifyObject = object => {
  const newObjData = {
    ...object,
    ludus: {
      type: 'unknown',
      id: uuid.v4(),
      ...object.ludus,
    },
  };

  // groups need recursive traversing
  if (newObjData.ludus.type === 'group' && newObjData.objects) {
    const newSubObjects = newObjData.objects.map(subObject =>
      identifyObject(subObject),
    );
    return {
      ...newObjData,
      objects: newSubObjects,
    };
  }

  return migrateJSON(newObjData);
};

/**
 * Loop through slide objects and identify them
 *
 * @param slide
 * @returns {{content: {objects}}}
 */
const identifyObjectsFromSlide = slide => {
  const newObjects = orderBy(
    Object.values(slide.content.objects || {}).map(identifyObject),
    'ludus.order',
  );
  return {
    ...slide,
    content: {
      ...slide.content,
      objects: newObjects,
    },
  };
};

/**
 * Loop through slides and identify objects within it
 *
 * @param slides
 */
export default function sanitizeSlides(slides) {
  return slides.map(identifyObjectsFromSlide);
}
